import React from 'react';

// Shown inside a page (header and footer stay) while its content loads, or when it could not be loaded.
// Usage: const c = useCollections('news'); if (c.loading || c.error) return <DataState state={c} />;
const DataState = ({ state }) => (
  <main>
    <div className="sc-data-state container text-center">
      {state.error ? (
        <>
          <h4>We could not load this page.</h4>
          <p>Please check your internet connection and try again.</p>
          <button type="button" className="ed-btn-theme" onClick={state.retry}>
            <span>Try again</span>
          </button>
        </>
      ) : (
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading</span>
        </div>
      )}
    </div>
  </main>
);

export default DataState;
